<script>
  export let data;
  export let done;
  export let cancel;

  import { Button, Card, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'sveltestrap';
  import { upload } from './datasets.js'

  let dropArea;
  let hi = false;
  let dsName = "auto";
  let fileValue;

  function handleFilesInput(e) {
    console.log("handleFilesInput - ", e, e.target.files)
    handleFiles(e.target.files);
    fileValue = "";
  }

  let formData;
  let loc;
  var idMap;
  let files;

  function init() {
    formData = new FormData();
    loc = '';
    idMap = {};
    files = [];
  }

  init();

  function handleFiles(pfiles) {
    files = [...pfiles];
    // formData.append("abc", "123");  this breaks the server parsing.. :(
    files.forEach(file => {
      console.log("handleFiles - appending", file);
      formData.append('file', file)
      console.log("handleFiles - keys", [...formData.keys()]);
    })
  }

  function handleUpload() {
    upload(formData, data.id, data.name, loc)
    .then(r => { 
      console.log("fileupload - done", r.status)
      done(r);
    })
    .catch(ex => { 
      console.log("fileupload-error", ex)
    })
    .finally(()=>{
      init();
    })
  }

  function highlight() {
    dropArea.classList.add('highlight')
    // console.log("drag hi", dropArea.style.classList, dropArea.classList)
    hi = true;
  }
  function unhighlight() {
    dropArea.classList.remove('highlight')
    console.log("drag lo")
    hi = false;
  }
  function dragenter(e) {
    e.preventDefault()
    e.stopPropagation()
    highlight();
  }
  function dragover(e) {
    e.preventDefault()
    e.stopPropagation()
    highlight();
  }
  function dragleave(e) {
    e.preventDefault()
    e.stopPropagation()
    unhighlight();
  }
  function drop(e) {
    e.preventDefault()
    e.stopPropagation()
    unhighlight();
    handleFiles(e.dataTransfer.files);
  }
</script>

<style>

.drop {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 1rem;
}

.hi {
  border: 2px solid green;
}

.drop * {
  margin: auto;
  width: 70%;
  display: block;
}

</style>
<Card body>
  <Row>
    <Col>
    
    <div class="drop" class:hi
    bind:this={dropArea} 
    on:dragenter={dragenter}
    on:dragover={dragover}
    on:dragleave={dragleave}
    on:drop={drop}
    >
      <input type=file multiple=false accept="*/*" on:change={handleFilesInput} bind:value={fileValue} >
      <label class="button" for="fileElem">Select one or more files or drop them here</label>
    </div>
    </Col>
  </Row>  
  <Row>
    <Col>
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>Table location</InputGroupText>
        </InputGroupAddon>
        <Input bind:value={loc} placeholder="Sheet1!A1 (ie first sheet, first cell by default)" />
      </InputGroup>
    </Col>
  </Row>  

  <Row>
    <Col>
      <Button class='m-1 ' on:click={handleUpload} color='primary'   >Upload</Button>
      <Button class='m-1 ' on:click={cancel} color='secondary' >Cancel</Button>
    </Col>
  </Row>
</Card>
